import styled from 'styled-components';

import { media } from '../../theme/media';
import { themeColor, themeSize, themeZIndex } from '../../theme/getters';

import { FiltersBar } from '../../shared/components/filtersBar';
import { MarketExperiences } from '../market/market.styles';
import { List } from '../experience/experiencesList/inlineList/inlineList.styles';
import { NoResults as NoResultsComponent } from '../../shared/components/noResults';
import { Title } from '../../shared/components/noResults/noResults.styles';

export const Container = styled.div`
  width: 100%;
  padding-top: 82px;
`;

export const FilteredExperiences = styled(MarketExperiences)`
  padding-top: 40px;

  ${media.tablet`
    padding: 80px 56px;
  `}

  ${List} {
    padding-top: 32px;

    ${media.tablet`
      padding-top: 80px;
    `};
  }
`;

export const FiltersBarSticky = styled(FiltersBar)`
  border-top: 1px solid ${themeColor('middleGray')};
  border-bottom: 1px solid ${themeColor('middleGray')};
  width: 100%;
  position: fixed;
  left: 0;
  top: calc(${themeSize('header')}px - 1px);
  z-index: ${themeZIndex('overContent')};
`;

export const LoadMoreButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const NoResults = styled(NoResultsComponent)`
  margin: 40px auto;
  max-width: 600px;

  ${media.tablet`
    margin-top: 80px;
  `}

  ${Title} {
    color: ${themeColor('primary')};
    margin-bottom: 0;

    ${media.tablet`
      margin-bottom: 80px;
    `}
  }
`;
